
import * as React from "react"
import * as PopoverPrimitive from "@radix-ui/react-popover"

import { cn } from "@/lib/utils"

const Popover = PopoverPrimitive.Root

const PopoverTrigger = PopoverPrimitive.Trigger

// Ancre le popover sur un élément SANS en faire le déclencheur : utile quand
// l'ouverture est pilotée ailleurs (ex. un item de menu ⋮) mais qu'on veut
// positionner le panneau à côté du bouton ⋮.
const PopoverAnchor = PopoverPrimitive.Anchor

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    /**
     * Portaliser le contenu vers le `body` (défaut). Poser `false` quand le
     * popover s'ouvre DANS une Dialog.
     *
     * WHY : une Dialog Radix pose un verrou de défilement (`react-remove-scroll`)
     * qui n'autorise la molette QUE dans son propre sous-arbre. Un popover
     * portalisé au `body` en sort — la liste s'affiche, la barre de défilement
     * fonctionne, mais la molette ne fait rien. Le garder dans la Dialog règle du
     * même coup son empilement : il n'a plus besoin d'un `z-index` supérieur,
     * puisqu'il en est un enfant.
     */
    portal?: boolean;
  }
>(({ className, align = "center", sideOffset = 4, portal = true, ...props }, ref) => {
  const content = (
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        "z-50 w-72 max-h-[70vh] rounded-md border border-grey-200 bg-popover p-4 text-popover-foreground shadow-sm outline-none overflow-y-auto scrollbar-thin scrollbar-thumb-grey-200 scrollbar-track-grey-100 dark:scrollbar-thumb-grey-600 dark:scrollbar-track-charcoal data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        className
      )}
      {...props}
    />
  );
  return portal ? <PopoverPrimitive.Portal>{content}</PopoverPrimitive.Portal> : content;
})
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export { Popover, PopoverTrigger, PopoverAnchor, PopoverContent }
